import React, { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import { legalApi } from '../lib/api';
import { ArrowLeft } from 'lucide-react';

const LegalPage = () => {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    legalApi.getPage(slug).then(setPage).catch(() => {}).finally(() => setLoading(false));
  }, [slug]);

  if (loading) return <div className="min-h-screen bg-[#030014] flex items-center justify-center"><div className="spinner" /></div>;
  if (!page) return (
    <div className="min-h-screen bg-[#030014] flex items-center justify-center">
      <div className="text-center">
        <p className="text-gray-400 text-lg mb-4">Page not found</p>
        <Link to="/" className="text-[#8B5CF6] hover:underline">Back to home</Link>
      </div>
    </div>
  );

  return (
    <div className="min-h-screen bg-[#030014] pt-8 pb-20" data-testid="legal-page">
      <div className="max-w-3xl mx-auto px-4 md:px-8">
        <Link to="/" className="inline-flex items-center gap-2 text-gray-400 hover:text-white mb-8 text-sm">
          <ArrowLeft className="w-4 h-4" /> Back
        </Link>
        <h1 className="text-3xl font-bold mb-2" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
          {page.title}
        </h1>
        <p className="text-xs text-gray-500 mb-8">Version {page.version} — Last updated: {new Date(page.updated_at).toLocaleDateString('en-US')}</p>
        <div className="prose prose-invert prose-sm max-w-none text-gray-300 leading-relaxed"
          dangerouslySetInnerHTML={{ __html: page.content }} />
      </div>
    </div>
  );
};

export default LegalPage;
